/**
 * Email Inbox guide — inbound email triggers and allowed sender filtering.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { emailInboxContent } from "@/constants/docs/email-inbox";

export const Route = createFileRoute("/docs/email-inbox")({
	component: EmailInboxPage,
});

function EmailInboxPage() {
	return <DocsPage title="Email Inbox" content={emailInboxContent} />;
}
